import { createSelector } from 'reselect';
import DespatchMonitoringReceptacleDetailsColumns from '../../containers/DespatchMonitoringReceptacleDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MONITORING_RECEPTACLE_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.DESPATCH_MONITORING_RECEPTACLE_DETAILS.isLoading;

export const getData = ReportDefinitions.DESPATCH_MONITORING_RECEPTACLE_DETAILS.getDataFunction();

export const getColumns = createSelector(getData, DespatchMonitoringReceptacleDetailsColumns);
